import { modalAnatomy } from '@chakra-ui/anatomy';

const chakraModalParts = modalAnatomy.keys;

const customModalParts = ['overline', 'headerActions'] as const;

type ChakraModalPart = (typeof chakraModalParts)[number];

type CustomModalPart = (typeof customModalParts)[number];

type ModalPart = ChakraModalPart | CustomModalPart;

export const MODAL_PARTS: readonly ModalPart[] = [
  ...chakraModalParts,
  ...customModalParts,
] as const;
